// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.metadata-item[data-v-7eaefaac]{\n    display: grid;\n    grid-template-columns: .7fr 1.3fr;\n    font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
